const light = ({ targetColorPalette }) => targetColorPalette[100];

export default light;
